// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"UserAvatar_ProseMirror__3yIy0","avatar":"UserAvatar_avatar__2GHxz"};